import styled from "styled-components";

export const Container = styled.div<{ isOpenMenu: boolean }>`
    position: absolute;
    bottom: 27px;
    left: ${({ isOpenMenu }) => (isOpenMenu ? "545px" : "90px")};
    background: white;
    border-radius: 12px;
    padding: 10px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    max-width: 380px;
    z-index: 1000;
    border: 1px solid rgba(0, 0, 0, 0.08);

    @media print {
        left: 10px;
    }
`;

export const Content = styled.div`
    background-color: #f0f0f0;
    border-radius: 8px;
    padding: 12px;

    & + & {
        margin-top: 8px;
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;


export const ContentFlex = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 6px;
`;


export const CheckColor = styled.span<{ backgroundColor?: string }>`
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: ${(props) => props.backgroundColor};

  -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    box-shadow: inset 0 0 0 1000px ${(props) => props.backgroundColor};
`;

export const Legend = styled.div`
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const Title = styled.div`
    font-size: 14px;
    font-weight: 500;
`;


export const MapLegendTotalValue = styled.div`
    font-size: 13px;
    font-weight: 600;
    color: #000;
`;
